export default __webpack_public_path__ + "static/media/8.e82c0a25.png";